module.exports = __webpack_public_path__ + "img/arrow.4120c678.svg";